import FingerprintJS from '@fingerprintjs/fingerprintjs';

const getDeviceId = async () => {
    const fp = await FingerprintJS.load({
        monitoring: false
    });

    const result = await fp.get();

    return result.visitorId;
};

export default getDeviceId;